export default {
    listaUnidades: new Array(),
    unidadeSelecionada: {cnes: null, nome: null},
    listagemEnfermarias: new Array(),
    enfermariaSelecionada: '',
    filtroCodEnfermaria: ''
}
